module.exports = __webpack_public_path__ + "static/media/left.edf39c3d.jpg";